import { render, staticRenderFns } from "./ShowImages.vue?vue&type=template&id=789d4478"
import script from "./ShowImages.vue?vue&type=script&lang=js"
export * from "./ShowImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('789d4478')) {
      api.createRecord('789d4478', component.options)
    } else {
      api.reload('789d4478', component.options)
    }
    module.hot.accept("./ShowImages.vue?vue&type=template&id=789d4478", function () {
      api.rerender('789d4478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/ambience/ShowImages.vue"
export default component.exports